import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=4bf9c3b4&scoped=true&"
import script from "./Swiper.vue?vue&type=script&lang=ts&"
export * from "./Swiper.vue?vue&type=script&lang=ts&"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=4bf9c3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9c3b4",
  null
  
)

export default component.exports